/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Card, Subheader, ListItem as MaterialListItem, Checkbox } from 'material-ui'

import * as constants from 'constants/Prestation'

class PrestationCriterias extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)
  }

  componentDidMount() {
    console.log("PrestationCriterias componentDidMount this.props.prestation:", this.props.prestation)
    if (this.props.prestation) {
        if (this.props.prestation.preferred_nationality_origin) {
            const selectedOrigin = this.props.origins.find((origin) => origin.nationality === this.props.prestation.preferred_nationality_origin)
            this.props.prestation.preferred_nationality_origin = selectedOrigin
        }
        // if (this.props.prestation.preferred_sex) {
        //     this.props.prestation.preferred_sex = selectedSex
        // }
        if (this.props.prestation.preferred_qualifications.length) {
            const selectedQualification = this.props.qualifications.find((qualification) => qualification.intermedia_value === this.props.prestation.preferred_qualifications[0].intermedia_value)
            this.props.prestation.preferred_qualifications = [selectedQualification]
        }
        if (this.props.prestation.preferred_skills.length) {
            const selectedSkill = this.props.skills.find((skill) => skill.value === this.props.prestation.preferred_skills[0].value)
            this.props.prestation.preferred_skills = [selectedSkill]
        }
        this.setState({
            interpreterListVisible: true
        })
    }
  }

  handleOriginSearch(e, checked) {
    let value
    if (checked) {
      value = this.props.origins.find((origin) => origin.uid === e.target.name)
    }

    this.props.handlePrestationChange('preferred_nationality_origin', value)
    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  handleGenderSearch(e, checked) {
    let value
    if (checked) {
      value = this.props.sexes.find((sex) => sex.uid === e.target.name)
    }

    this.props.handlePrestationChange('preferred_sex', value)
    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  handleQualificationSearch(e, checked) {
    if (checked) {
      const value = this.props.qualifications.find((qualification) => qualification.uid === e.target.name)
      this.props.handlePrestationChange('preferred_qualifications', [value])
    } else {
      this.props.handlePrestationChange('preferred_qualifications', [])
    }

    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  handleSkillSearch(e, checked) {
    if (checked) {
      const value = this.props.skills.find((skill) => skill.uid === e.target.name)
      this.props.handlePrestationChange('preferred_skills', [value])
    } else {
      this.props.handlePrestationChange('preferred_skills', [])
    }

    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  render() {
    const prestation = this.props.prestation

    return (
      <Card
        style={{height: '100%'}}
      >
				<Subheader style={{textAlign: 'center'}}>
          {this.props.intl.formatMessage(constants.messages.PRESTATION_CRITERIAS)}
        </Subheader>

        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <MaterialListItem
              primaryText={this.props.intl.formatMessage(constants.messages.NATIONALITY_ORIGIN)}
              initiallyOpen={false}
              primaryTogglesNestedList={true}
              nestedListStyle={{padding: 0}}
              style={styles.fontText}
              nestedItems={[
                this.props.origins.map((origin, i) => (
                  <div
                    style={styles.option}
                    key={origin.uid}
                  >
                    <Checkbox
                      name={origin.uid}
                      label={origin.nationality}
                      checked={
                        prestation.preferred_nationality_origin &&
                        prestation.preferred_nationality_origin.uid === origin.uid
                      }
                      onCheck={this.handleOriginSearch}
                      labelStyle={styles.fontText}
                      disabled={prestation.choosenInterpreter || !!prestation.uid}
                    />
                  </div>
                ))
              ]}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <MaterialListItem
              primaryText={this.props.intl.formatMessage(constants.messages.GENDER)}
              initiallyOpen={false}
              primaryTogglesNestedList={true}
              nestedListStyle={{padding: 0}}
              style={styles.fontText}
              nestedItems={[
                this.props.sexes.map((sex, i) => (
                  <div
                    style={styles.option}
                    key={sex.uid}
                  >
                    <Checkbox
                      name={sex.uid}
                      label={sex.value}
                      checked={prestation.preferred_sex && prestation.preferred_sex.uid === sex.uid}
                      onCheck={this.handleGenderSearch}
                      labelStyle={styles.fontText}
                      disabled={prestation.choosenInterpreter || !!prestation.uid}
                    />
                  </div>
                ))
              ]}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <MaterialListItem
              primaryText={this.props.intl.formatMessage(constants.messages.QUALIFICATIONS)}
              initiallyOpen={false}
              primaryTogglesNestedList={true}
              nestedListStyle={{padding: 0}}
              style={styles.fontText}
              nestedItems={[
                this.props.qualifications.map((qualification, i) => (
                  <div
                    style={styles.option}
                    key={qualification.uid}
                  >
                    <Checkbox
                      name={qualification.uid}
                      label={qualification.intermedia_value}
                      checked={
                        !!(prestation.preferred_qualifications.length &&
                           prestation.preferred_qualifications[0].uid === qualification.uid)
                      }
                      onCheck={this.handleQualificationSearch}
                      labelStyle={styles.fontText}
                      disabled={prestation.choosenInterpreter || !!prestation.uid}
                    />
                  </div>
                ))
              ]}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <MaterialListItem
              primaryText={this.props.intl.formatMessage(constants.messages.SKILLS)}
              initiallyOpen={false}
              primaryTogglesNestedList={true}
              nestedListStyle={{padding: 0}}
              style={styles.fontText}
              nestedItems={[
                this.props.skills.map((skill, i) => (
                  <div
                    style={styles.option}
                    key={skill.uid}
                  >
                    <Checkbox
                      name={skill.uid}
                      label={skill.value}
                      checked={
                        !!(prestation.preferred_skills.length &&
                           prestation.preferred_skills[0].uid === skill.uid)
                      }
                      onCheck={this.handleSkillSearch}
                      labelStyle={styles.fontText}
                      disabled={prestation.choosenInterpreter || !!prestation.uid}
                    />
                  </div>
                ))
              ]}
            />
          </div>
        </div>
			</Card>
    )
  }
}

const styles = {
  option: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 5
  },
  fontText: {
    fontSize: 14
  },
}

const mapStateToProps = (state) => ({
  sexes: state.ApplicantPrestation.sexes,
  qualifications: state.ApplicantPrestation.qualifications,
  skills: state.ApplicantPrestation.skills,
})

export default connect(mapStateToProps, undefined)(injectIntl(PrestationCriterias))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/PrestationCriterias.js